import { inject } from '@angular/core';
import { LearnerApiService, CourseLevelApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { COURSE_LEVEL_SELECT_CONFIG, ENROLMENT_STATUS_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const enrolmentFormConfig = (): FormConfig => {
  const learnerApiService = inject(LearnerApiService);
  const courseLevelApiService = inject(CourseLevelApiService);

  // Learner select config
  const LEARNER_SELECT_CONFIG = {
    service: learnerApiService,
    method: 'getLearnerOptions',
    idField: 'id',
    labelFormatter: (learner: any) => `${learner.code} - ${learner.fullname || 'N/A'}`,
    valueField: 'id',
    placeholder: 'Chọn học viên',
    sortField: 'code,asc',
    usePostMethod: true,
    bodyBuilder: (searchTerm: string, baseQuery: any, idQuery?: any) => {
      const body: any = {};
      const trimmedSearchTerm = searchTerm.trim();

      if (idQuery && idQuery.id) {
        body.andQ = { id: idQuery.id };
      } else if (searchTerm && trimmedSearchTerm) {
        body.orQ = {
          code: trimmedSearchTerm,
          fullname: trimmedSearchTerm
        };
      }

      if (baseQuery && Object.keys(baseQuery).length > 0) {
        if (!body.andQ) {
          body.andQ = {};
        }
        body.andQ = { ...body.andQ, ...baseQuery };
      }

      return body;
    }
  };

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'learnerId', label: 'Học viên', required: true, width: 'full',
        type: 'select', config: LEARNER_SELECT_CONFIG,
        disabled: (editMode) => editMode
      },
      {
        key: 'levelId', label: 'Level', required: false, width: 'half',
        type: 'select', config: { ...COURSE_LEVEL_SELECT_CONFIG, service: courseLevelApiService }
      },
      {
        key: 'status', label: 'Trạng thái', required: false, width: 'half',
        type: 'select', config: ENROLMENT_STATUS_SELECT_CONFIG
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập ghi chú'
      }
    ]
  };
};

